import React, { useEffect, useState } from 'react'

import { useParams, useNavigate, useLocation } from 'react-router-dom'

import ProfessorIndividualClass from './ProfessorIndividualClass'
import ProfessorSharedProccess from './ProfessorSharedProccess'
import ProfessorsList from './ProfessorsList'
import {
  SectionSubtitle,
  InlineMenuNoButton,
  DetailPerson,
  DeleteUserButton,
  Button,
} from '../../..'
import { useCupons, useProfessors, useUser } from '../../../../context'
import { AdminProfessorMenu, AnyProfile } from '../../../../types'
import { convertToRoles } from '../../../../utilFunctions'
import { Spacer } from '../../../global'
import TeacherInvoice from '../../../invoice/TeacherInvoice'
import DeleteUserModal from '../../../modal/DeleteUserModal'
import ProfileView from '../../../profile/ProfileView'
import { AdminsContainer, ProfileDataSection } from '../styles'

const Professors = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { part } = useParams<{ user: string; part: string }>()

  const { activeProfessor, setActiveProfessor, saveProfessor, professorsList } =
    useProfessors()
  const { onEditionMode, setOnEditionMode } = useUser()
  const { cupons, setProfessorCupons } = useCupons()

  const [showConfirmationDeleteModal, setShowConfirmationDeleteModal] =
    useState<boolean>(false)

  // const selectProfessor = (professor: Profesor) => {
  //   if (!onEditionMode) {
  //     setActiveProfessor(professor)

  //     navigate(`/profesores/${AdminProfessorMenu.activity.label}`)
  //   } else {
  //     setActiveProfessor(professor)
  //   }
  // }

  const updateProfile = () => {
    if (activeProfessor) {
      saveProfessor(activeProfessor, activeProfessor.uid)
      setOnEditionMode(!onEditionMode)
    }
  }

  useEffect(() => {
    if (activeProfessor) {
      const filterCupons = cupons.filter(
        (item) => item.teacher === activeProfessor.uid,
      )

      setProfessorCupons(filterCupons)
    }
  }, [activeProfessor, cupons])

  useEffect(() => {
    if (activeProfessor === null && !onEditionMode && professorsList) {
      setActiveProfessor(professorsList[0])
      navigate(`/profesores/${AdminProfessorMenu.activity.label}`)
    }
  }, [])

  const resetProfessors = () => {
    setActiveProfessor(null)
    setOnEditionMode(false)
    professorsList && setActiveProfessor(professorsList[0])
    navigate(`/profesores/${AdminProfessorMenu.activity.label}`)
    setShowConfirmationDeleteModal(false)
  }

  return (
    <AdminsContainer>
      {showConfirmationDeleteModal && (
        <DeleteUserModal resetUsers={resetProfessors} />
      )}
      <ProfessorsList />

      <div className="data">
        {activeProfessor && (
          <>
            {/* <Section> */}
            <InlineMenuNoButton
              parent="profesores"
              menu={AdminProfessorMenu}
              editing={onEditionMode}
            />
            {part !== AdminProfessorMenu.profile.label && (
              <ProfileDataSection>
                <DetailPerson person={activeProfessor} />

                {!onEditionMode && activeProfessor && (
                  <DeleteUserButton
                    userToDeleteUID={activeProfessor.uid}
                    userToDeleteRole={convertToRoles(
                      activeProfessor.role as string,
                    )}
                    setActiveUserNull={resetProfessors}
                  />
                )}
              </ProfileDataSection>
            )}

            <div>
              <div className="section-title">
                <SectionSubtitle fontWeight={500} fontSize={16} lineHeight={24}>
                  <>
                    {part === AdminProfessorMenu.activity.label
                      ? AdminProfessorMenu.activity.description
                      : part === AdminProfessorMenu.profile.label
                        ? AdminProfessorMenu.profile.description
                        : AdminProfessorMenu.shared.description}
                  </>
                </SectionSubtitle>
                {!onEditionMode &&
                  part === AdminProfessorMenu.profile.label && (
                    <div className="buttons-row">
                      <Button
                        label="Editar"
                        disabled={onEditionMode}
                        onClick={updateProfile}
                      />

                      {activeProfessor && (
                        <DeleteUserButton
                          userToDeleteUID={activeProfessor.uid}
                          userToDeleteRole={convertToRoles(
                            activeProfessor.role as string,
                          )}
                          setActiveUserNull={resetProfessors}
                        />
                      )}
                    </div>
                  )}
              </div>
              <Spacer height={16} />
            </div>

            {part === AdminProfessorMenu.activity.label && (
              <>
                <ProfessorIndividualClass />
                {/* <Activities classesList={classesList} /> */}

                <Spacer height={50} />

                <TeacherInvoice />
              </>
            )}
            {part === AdminProfessorMenu.profile.label && (
              <ProfileView
                initialProfile={activeProfessor as AnyProfile}
                isNewUser={pathname === '/nuevo-usuario'}
              />
            )}
            {part === AdminProfessorMenu.shared.label && (
              <>
                <Spacer height={32} />
                <ProfessorSharedProccess
                  professorId={activeProfessor.uid}
                  professorName={`${activeProfessor.name} ${activeProfessor.lastname}`}
                />
              </>
            )}
          </>
        )}
      </div>
    </AdminsContainer>
  )
}

export default Professors
